import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { CreateLeaveTypeDTO } from "@/modules/hr/leave/domain/types";
import { Button, toast } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeft, HelpCircle } from "lucide-react";
import { useCreateLeaveTypeMutation } from "../api/queries";
import {
    LeaveTypeCreateTour,
    useLeaveTypeCreateTour,
} from "../tour/LeaveTypeCreateTour";
import { LeaveTypeForm } from "../ui/LeaveTypeForm";

const LIST_SEARCH = {
  offset: 0,
  limit: 20,
  sort: undefined as { field: string; dir: "asc" | "desc" }[] | undefined,
  isActive: undefined as boolean | undefined,
  search: undefined as string | undefined,
};

export function LeaveTypeCreatePage() {
  const nav = useNavigate();
  const createMutation = useCreateLeaveTypeMutation();
  const tour = useLeaveTypeCreateTour();

  const handleBack = () => {
    nav({ to: "/app/hr/leave/types", search: LIST_SEARCH });
  };

  const handleSubmit = (values: CreateLeaveTypeDTO) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        toast.success("ສ້າງປະເພດການລາສຳເລັດ");
        nav({ to: "/app/hr/leave/types", search: LIST_SEARCH });
      },
      onError: (err) => {
        toast.error(err?.message ?? "ເກີດຂໍ້ຜິດພາດ");
      },
    });
  };

  return (
    <>
      <Header />
      <Main>
        <LeaveTypeCreateTour
          run={tour.run}
          onCallback={tour.handleJoyrideCallback}
        />
        <div
          className="mb-6 flex items-center justify-between gap-2"
          data-tourid="leave-type-create-back"
        >
          <div>
            <div className="flex items-center gap-2">
              <h1 className="font-semibold text-2xl">ສ້າງປະເພດການລາ</h1>
              <Button
                variant="ghost"
                size="icon"
                className="size-7 rounded-full"
                onClick={tour.startTour}
                title="ເລີ່ມທົດສອບການນຳທາງ"
                aria-label="ເລີ່ມທົດສອບການນຳທາງ"
              >
                <HelpCircle className="size-5" />
              </Button>
            </div>
            <p className="text-muted-foreground text-sm">ສ້າງປະເພດການລາໃໝ່</p>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleBack}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            ກັບໄປລາຍການ
          </Button>
        </div>

        <div
          className="mx-auto w-full max-w-4xl space-y-6"
          data-tourid="leave-type-create-form"
        >
          <LeaveTypeForm
            mode="create"
            onSubmit={handleSubmit}
            onCancel={handleBack}
            isSubmitting={createMutation.isPending}
          />
        </div>
      </Main>
    </>
  );
}
